export const click = 'click' as const;
export const comment = 'reaction_comment' as const;
export const like = 'reaction_like' as const;
export const open = 'open' as const;
export const play = 'play' as const;
export const sent = 'sent' as const;
export const videoWatched = 'video_watched' as const;
export const insertVideo = 'insert_video' as const;
export const videoSaved = 'video_saved' as const;
export const replyWithVideo = 'reaction_rwv' as const;

export const EMAIL_TYPES = [sent, open, click, play] as const;
export type EmailLivefireCardType = (typeof EMAIL_TYPES)[number];

export const EVENT_TYPES = [insertVideo, videoSaved] as const;
export type EventLivefireItemType = (typeof EVENT_TYPES)[number];

export const items = [...EMAIL_TYPES, ...EVENT_TYPES, comment, like, videoWatched, replyWithVideo];

export type LivefireCardType = (typeof items)[number];

export type FilterStateKey = (typeof items)[number];
export type FilterState = Record<FilterStateKey, boolean>;
